import { render, staticRenderFns } from "./AddRadioForm.vue?vue&type=template&id=365cb227&scoped=true"
import script from "./AddRadioForm.vue?vue&type=script&lang=js"
export * from "./AddRadioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365cb227",
  null
  
)

export default component.exports